import { render, staticRenderFns } from "./NewPlans.vue?vue&type=template&id=05c5a33c&scoped=true"
import script from "./NewPlans.vue?vue&type=script&lang=js"
export * from "./NewPlans.vue?vue&type=script&lang=js"
import style0 from "./NewPlans.vue?vue&type=style&index=0&id=05c5a33c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c5a33c",
  null
  
)

export default component.exports